import { Button, message, Select } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import { ArrayOption, selectSearchOption } from "../../../helpers/siteConfig";
import { toast } from "../../../helpers/toast";
import useExcelDownload from "../../../hooks/useExcelDownload";
import {
  getAllAreaAsync,
  getAllRegionAsync,
  getAllTerritoryAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { uploadTicketExcelAsync } from "../../../store/features/NP/network/networkAPI";
import { getAllUsersAsync } from "../../../store/features/NP/resource/resourceAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { stringToArray } from "../../../utils/array";
import { sliceString } from "../../../utils/string";
import CustomModal from "../../common/CustomModal";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  reRender: (val: boolean) => void;
  uploadedCount: (val: number, total: number) => void;
  filter?: {
    regionId?: string;
    areaId?: string;
    territoryId?: string;
    supplierId?: string;
    date?: any;
    today?: boolean;
    clusterId?: string;
    zoneId?: string;
  };
};

export default function ImportExcel({
  open,
  handleClose,
  data,
  reRender,
  uploadedCount,
  filter,
}: Props) {
  const dispatch = useAppDispatch();
  const { regions, areas, territorys } = useAppSelector((state) => state.npGeo);
  const [fileName, setFileName] = useState("No file chosen");
  const [loading, setLoading] = useState(false);
  const [uploadedData, setUploadedData] = useState<any[] | any>([]);
  const { allUsers, loading: userLoading } = useAppSelector(
    (state) => state.resource
  );
  const { excelLoading, downloadExcel, handleExcelLoading } =
    useExcelDownload("Tower-List");
  const [uploadLoading, setUploadLoading] = useState(false);
  const { postLoading } = useAppSelector((state) => state.network);
  const [regionId, setRegionId] = useState<string | undefined>(undefined);
  const [areaId, setAreaId] = useState(undefined);
  const [territoryId, setTerritoryId] = useState(undefined);

  const handleUploadFile = (file: any) => {
    if (
      file?.name?.endsWith(".xls") ||
      file?.name?.endsWith(".xlsx") ||
      file?.type === "application/vnd.ms-excel" ||
      file?.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setLoading(true);
      const reader = new FileReader();
      reader.readAsBinaryString(file);

      const fileNameArr = stringToArray(file?.name, ".");
      setFileName(
        `${sliceString(file?.name, 30, "...")}.${
          fileNameArr?.[fileNameArr?.length - 1]
        }`
      );

      reader.onload = (e) => {
        const data = e?.target?.result;
        const workBook = XLSX.read(data, {
          type: "binary",
          cellDates: true,
          dateNF: "mm/dd/yyyy",
        });
        const sheetName = workBook.SheetNames[0];
        const sheet = workBook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet, { raw: false });

        // const filteredData = parsedData?.filter(
        //   (el: any) =>
        //     el?.["ID"] &&
        //     // el?.["Tower Name"] &&
        //     // (el?.["Standard Operating Rate"] ||
        //     //   el?.["Standard Operating Rate"] === 0) &&
        //     el?.["Date"] &&
        //     el?.["Time"],
        // );
        const generateTowerData = (parsedData: any[], filter: any) => {
          const isPositiveNumber = (value: number | string) => {
            return typeof value === "number" && !isNaN(value) && value >= 0;
          };
          const hasSpecialCharacters = (str: string, allowedChars = "") => {
            if (typeof str !== "string") return false;

            // Escape allowed characters for regex
            const escapedAllowed = allowedChars.replace(
              /[-\/\\^$*+?.()|[\]{}]/g,
              "\\$&"
            );

            // Regex: match special characters except allowed ones and underscore
            const regex = new RegExp(`[^a-zA-Z0-9_${escapedAllowed}]`);

            return regex.test(str);
          };

          const isValidBDMobile = (number: number | string) => {
            if (typeof number !== "string") number = String(number).trim();

            // Valid formats:
            // 01XXXXXXXXX (11 digits)
            // +8801XXXXXXXXX (with country code)
            // 1XXXXXXXXX (optional 0 before 1)
            const regex = /^(?:\+?8801[3-9]\d{8}|0?1[3-9]\d{8})$/;

            return regex.test(number);
          };

          const noSpecials = (str: string | number, allow = "") => {
            return (
              isPositiveNumber(Number(str)) &&
              !hasSpecialCharacters(str as string, allow)
            );
          };

          let isError = false;
          const errors: number[] = [];

          const data = parsedData.map((el, indx) => {
            const kpi = [];
            const isValidLatitude = !hasSpecialCharacters(el["Latitude"], ".");
            const isValidLongitude = !hasSpecialCharacters(
              el["Longitude"],
              "."
            );
            const isValidContactNo = isValidBDMobile(el["Contact No"]);
            const isValidOptionalContactNo = isValidBDMobile(
              el["Optional Contact No"]
            );
            const isValidRadius = noSpecials(el["radius"]);
            const isValidRobiId = !hasSpecialCharacters(el["Robi ID"], " -");
            const isValidGpId = !hasSpecialCharacters(el["GP ID"], " -");
            const isValidSiteCode = !hasSpecialCharacters(
              el["Site Code"],
              " -"
            );
            console.log(el);
            const towerType = el["Tower Type"];

            if (towerType !== "s" && towerType !== "p") {
              if (!isError) {
                isError = true;
              }

              toast(
                "error",
                `Invalid Tower Type value found in row ${indx + 1}`
              );
            }
            if (!isValidLatitude) {
              if (!isError) {
                isError = true;
              }
              toast("error", `Invalid Latitude value found in row ${indx + 1}`);
            } else if (!isValidLongitude) {
              if (!isError) {
                isError = true;
              }

              toast(
                "error",
                `Invalid Longitude value found in row ${indx + 1}`
              );
            }
            // else if (!isValidContactNo) {
            //   if (!isError) {
            //     isError = true;
            //   }
            //   toast(
            //     "error",
            //     `Invalid contact no value found in row ${indx + 1}`
            //   );
            // }
            //  else if (!isValidOptionalContactNo) {
            //   if (!isError) {
            //     isError = true;
            //   }
            //   toast(
            //     'error',
            //     `Invalid optional contact no value found in row ${indx + 1}`,
            //   );
            // }
            else if (!isValidRadius) {
              if (!isError) {
                isError = true;
              }
              toast("error", `Invalid radius value found in row ${indx + 1}`);
            }
            // else if (!isValidRobiId) {
            //   if (!isError) {
            //     isError = true;
            //   }
            //   toast('error', `Invalid Robi ID value found in row ${indx + 1}`);
            // } else if (!isValidGpId) {
            //   if (!isError) {
            //     isError = true;
            //   }
            //   toast('error', `Invalid GP ID value found in row ${indx + 1}`);
            // }
            else if (!isValidSiteCode) {
              if (!isError) {
                isError = true;
              }
              toast(
                "error",
                `Invalid Site Code value found in row ${indx + 1}`
              );
            }
            // else if (!isValidEasiCode) {
            //   if (!isError) {
            //     isError = true;
            //   }
            //   toast(
            //     "error",
            //     `Invalid Easi Code value found in row ${indx + 1}`,
            //   );
            // }

            if (el["Robi ID"]) {
              kpi.push("robi");
            }
            if (el["GP ID"]) {
              kpi.push("gp");
            }
            // if (el["radius"] && Number(el["radius"]) < 0) {
            //   errors.push(indx + 1);
            // }
            // if (
            //   parsedData?.lastIndexOf(el["radius"]) &&
            //   Number(el["radius"]) < 0
            // ) {
            //   errors.push(indx + 1);
            // }
            return {
              towerName: el["Tower Name"] || "",
              towerType: el["Tower Type"] || "",
              siteCode: el["Site Code"] || "",
              easiCode: el["Easi Code"] || "",
              robiId: el["Robi ID"] || "",
              gpId: el["GP ID"] || "",
              latitude: el["Latitude"] || "",
              longitude: el["Longitude"] || "",
              contactNo: `${el["Contact No"]}` || "",
              address: el["Address"] || "",
              kpi,
              radius: el["radius"] || "",
              contactPersonName: el["Contact Person Name"] || "",
              optionalContactNo: `${el["Optional Contact No"]}` || "",
              territoryName: el["Teritory Name"] || "",
              areaName: el["Area Name"] || "",
              regionName: el["Region Name"] || "",
              checkList: [
                "Commercial Power",
                "Rectifier Controller",
                "Battery",
              ],
            };
          });
          if (isError) {
            // toast(
            //   "error",
            //   `Invalid radius value found in row(s): ${errors.join(", ")}`,
            // );
            return [];
          } else {
            return data;
          }
        };

        const finalData = generateTowerData(parsedData, filter);
        setUploadedData(finalData);
        setLoading(false);
      };
    } else {
      setLoading(false);
      toast("error", "Please upload only excel file");
    }
  };
  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    if (regionId)
      dispatch(
        getAllAreaAsync({
          params: {
            region: regionId,
          },
        })
      );
  }, [dispatch, regionId]);

  useEffect(() => {
    if (areaId)
      dispatch(
        getAllTerritoryAsync({
          params: {
            area: areaId,
          },
        })
      );
  }, [dispatch, areaId]);
  const handleDownloadExcel = async () => {
    handleExcelLoading(true);
    let excelData = [] as any[];

    // await AXIOS.post(BASE_API.getAllTower, null, {
    //   params: { limit: 1000, skip: 0 },
    // })
    //   .then((res) => {
    //     const responseData = res?.data?.getData as GetAllTowerData[];

    //     responseData?.forEach((el, idx) => {

    //     });
    //   })
    //   .catch(() => {
    //     handleExcelLoading(false);
    //     toast("error", "Download fail! Please try again");
    //   });

    let data = {} as any;

    data["Tower Name"] = "";
    data["Tower Type"] = "";
    data["Site Code"] = "";
    data["Easi Code"] = "";
    data["Robi ID"] = "";
    data["GP ID"] = "";
    data["Latitude"] = "";
    data["Longitude"] = "";
    data["Contact No"] = "";
    data["Address"] = "";
    // data["KPI"] = "";
    data["radius"] = "";
    data["Contact Person Name"] = "";
    data["Optional Contact No"] = "";
    data["Teritory Name"] = "";
    data["Area Name"] = "";
    data["Region Name"] = "";

    excelData.push(data);

    downloadExcel(excelData);
  };

  const handleUpload = async () => {
    setUploadLoading(true);
    let uploadData = [] as any[];
    if (!regionId || !areaId || !territoryId) {
      message.error(
        "Please select region, area and territory to download excel file"
      );
      setUploadLoading(false);
      return;
    }
    // console.log('Uploaded Data:', {
    //   towerArray: uploadedData,
    //   regionId: regionId || '',
    //   areaId: areaId || '',
    //   territoryId: territoryId || '',
    //   territoryName:
    //     territorys?.find((el) => el?._id === territoryId)?.teritoryName || '',
    //   regionName: regions?.find((el) => el?._id === regionId)?.regionName || '',
    //   areaName: areas?.find((el) => el?._id === areaId)?.areaName || '',
    // });
    try {
      // const promises = uploadedData?.map((el: any) =>
      //   AXIOS.get(`${BASE_API.bulkUploadTower}`)
      //     .then((data) => {
      //       const ticketData = data?.data?.getData;

      //       const {
      //         checkList,
      //         longitude,
      //         latitude,
      //         contactNo,
      //         towerName,
      //         _id,
      //         siteCode,
      //         region,
      //         regionName,
      //         area,
      //         areaName,
      //         teritory,
      //         teritoryName,
      //         optionalContactNo,
      //         address,
      //         radius,
      //         kpi,
      //         contactPersonName,
      //       } = ticketData;

      //       // console.log(
      //       //   el["Date"],
      //       //   moment(new Date(el["Date"])).format("DD/MM/YYYY")
      //       // );

      //       const newData = {
      //         region: region?._id,
      //         area: area?._id,
      //         teritory: teritory?._id,
      //         regionName,
      //         areaName,
      //         teritoryName,
      //         checkList,
      //         longitude,
      //         latitude,
      //         contactNo,
      //         towerName,
      //         siteCode,
      //         tower: _id,
      //         offTime: formatTicketTime(el["Time"]),
      //         date: moment(new Date(el["Date"])).format("DD/MM/YYYY"),
      //         sorOne: el["Standard Operating Rate (X)"],
      //         perMinuteCharge: el["Standard Operating Rate (Y)"],
      //         requestList: allUsers
      //           ?.filter((item) => item?.teritory?._id === teritory?._id)
      //           ?.map((el) => ({
      //             user: el?._id,
      //           })),
      //         optionalContactNo,
      //         address,
      //         radius,
      //         kpi,
      //         contactPersonName,
      //       };

      //       uploadData.push(newData);
      //     })
      //     .catch((error) => {
      //       console.error(`Error fetching data for ID: ${el["ID"]}`, error);
      //       toast("error", "Fail to upload data");
      //     }),
      // );
      const res = await AXIOS.post(`${BASE_API.bulkUploadTower}`, {
        towerArray: uploadedData,
        regionId: regionId || "",
        areaId: areaId || "",
        territoryId: territoryId || "",
        territoryName:
          territorys?.find((el) => el?._id === territoryId)?.teritoryName || "",
        regionName:
          regions?.find((el) => el?._id === regionId)?.regionName || "",
        areaName: areas?.find((el) => el?._id === areaId)?.areaName || "",
      });

      console.log(res);
      if (res?.data?.status) {
        handleClose();
        toast("success", "Excel data uploaded successfully");
      }
      // Wait for all the promises to resolve
      // await Promise.all(promises);
      if (uploadData.length > 0) {
        dispatch(
          uploadTicketExcelAsync({
            data: uploadData,
            others: {
              reRender,
              uploadedCount,
            },
          })
        );
      }
    } catch (error) {
      console.error("Error during the upload process", error);
      toast("error", "Error during the upload process");
    } finally {
      setUploadLoading(false);
    }
  };

  // function successDone(id: string) {
  //   setCountUpload((prev) => prev + 1);
  //   dispatch(
  //     towerTicketNotificationAsync({
  //       data: { towerTicketId: id },
  //       others: null,
  //     })
  //   );
  // }

  useEffect(() => {
    dispatch(getAllUsersAsync({}));
  }, [dispatch]);

  return (
    <CustomModal
      width={600}
      title="Excel Sheet"
      open={open}
      handleClose={!uploadLoading && !postLoading ? handleClose : () => {}}
    >
      <div className="p-6">
        <label className="text-[#3d4a5c] text-sm font-medium leading-normal mb-1.5 inline-block">
          Import Excel File
        </label>
        <Dragger
          name="file"
          action=""
          accept=".xlsx, .xls"
          maxCount={1}
          showUploadList={false}
          beforeUpload={() => false}
          onChange={(info) => handleUploadFile(info.file)}
          onDrop={(e) => handleUploadFile(e.dataTransfer.files[0])}
          // excelPostLoading ||
          disabled={loading || uploadLoading || postLoading}
          className="import_excel"
        >
          <Button
            className="flex justify-between items-center"
            size="large"
            disabled={loading || uploadLoading || postLoading}
            style={{ width: "100%" }}
          >
            <div className="flex items-center gap-2 text-sm font-normal font-roboto text-[#8797ae]">
              <span className="text-accent font-medium text-base leading-7 relative">
                Choose File
              </span>
              <span className="border-r border-solid border-l-0 border-y-0 border-others-border h-4" />
              {loading ? "Uploading..." : fileName}
            </div>
          </Button>
        </Dragger>

        <div className="grid grid-cols-3 gap-2 mt-2">
          <Select
            value={regionId}
            placeholder="Select cluster"
            allowClear
            showSearch
            size="large"
            filterOption={selectSearchOption}
            options={ArrayOption(regions, "regionName", "_id", true)}
            onChange={(val) => {
              setRegionId(val);
              setAreaId(undefined);
              setTerritoryId(undefined);
            }}
            className="min-w-[120px]"
            // disabled={login?.role === "region" || login?.role === "finance"}
          />
          <Select
            placeholder="Select zone"
            allowClear
            showSearch
            size="large"
            filterOption={selectSearchOption}
            options={ArrayOption(areas, "areaName", "_id", true)}
            onChange={(val) => {
              setAreaId(val);
              setTerritoryId(undefined);
            }}
            value={areaId}
            disabled={!regionId}
            className="min-w-[120px]"
          />
          <Select
            placeholder="Maintenance point "
            allowClear
            showSearch
            size="large"
            filterOption={selectSearchOption}
            options={ArrayOption(territorys, "teritoryName", "_id", true)}
            onChange={(val) => {
              setTerritoryId(val);
            }}
            value={territoryId}
            disabled={!areaId}
            className="min-w-[120px]"
            optionFilterProp="children"
          />
        </div>

        <div className="px-4 py-[9px] bg-[#fffbe6] rounded-md border border-[#ffe58f] text-sm text-[#874d00] mt-4">
          <span className="font-medium">Warning! </span>
          <span>
            Upload only xlsx file. For any blank column put N/A, otherwise data
            will be mismatch. Your can see sample file,{" "}
          </span>
          <button
            className="text-[#1890ff] cursor-pointer text-sm font-medium bg-transparent border-none"
            onClick={handleDownloadExcel}
            disabled={excelLoading}
          >
            click here
          </button>
        </div>

        <div className="flex justify-center mt-7">
          <Button
            size="large"
            type="primary"
            className="w-72 !h-12"
            onClick={handleUpload}
            disabled={loading || userLoading || uploadedData?.length === 0}
            loading={uploadLoading || postLoading}
          >
            Upload
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}

function formatTicketTime(input: string): string {
  const timeOnlyPattern = /^\d{1,2}:\d{2}\s?(AM|PM)$/i;

  let date: Date;

  if (timeOnlyPattern.test(input)) {
    const today = new Date();
    const todayDateString = today.toISOString()?.split("T")[0];
    const dateTimeString = `${todayDateString} ${input}`;
    date = new Date(dateTimeString);
  } else {
    date = new Date(input);
  }

  // Return the time in 12-hour format with AM/PM
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}
